import { swSettings } from "app/common/services/swSettings";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import type { IFilterHandlerReturnObj, IParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { getCountryRequiredChanges } from "app/routes/handlers/filter-consistency/handlers/country/countryFilterConsistencyHandler";

// should be used in pages with special countries list, meaning they have more open countries
// than in their purchased package. In example SERP pages (paid landing pages and search ads)
// and display pages (creatives and videos) that have access to all/more countries regardless
// of the user’s package.
export const getOpenCountryFilterRequiredChanges = (
    componentConfigId: string | null,
    selectedCountry: string | number,
    openSelectedCountry: string | number,
    targetState: IRouterState,
    toParams: IParams,
): IFilterHandlerReturnObj => {
    if (openSelectedCountry) {
        // @ts-ignore FIXME: strict migration - Argument of type 'string | number' is not assignable to parameter of type 'string'
        const isAllowed = swSettings.allowedCountry(openSelectedCountry, componentConfigId);
        if (isAllowed) {
            return {
                isAllowed,
                displayChangeIndicator: false,
                isChanged: false,
                shouldChangeToSelected: openSelectedCountry !== +toParams.country,
                value: openSelectedCountry.toString(),
            };
        }
    }
    return getCountryRequiredChanges(componentConfigId, selectedCountry, targetState, toParams);
};
